import React from 'react'
import ContentModal from '../ContentModal'
import FormTestDrive from '../ContentForms/TestDrive'
import { ModalSection } from '../ContentModalSection/components/ModalSectionStyled'

const TestDriveModal = (props) => {
  const {
    show,
    onClose,
    newVehicle,
    vehicleId,
    locations,
    brand,
    brandSpecific
  } = props
  return show ? (
    <ContentModal title=" Register Interest" open onClose={onClose}>
      <ModalSection width={'100%'} py={20} px={'7%'}>
        <FormTestDrive
          newVehicle={newVehicle}
          vehicleId={vehicleId}
          locations={locations}
          brandSpecific={brandSpecific}
          brand={brand}
        />
      </ModalSection>
    </ContentModal>
  ) : null
}

export default TestDriveModal
